import createModelInstance from 'utils/createModelInstance';

const Engraving = (engravingInput) => {
    /**
     * Assign the data from an object coming from the Sugar API
     */
    let newEngravingObj = {
        id: '',
        bookingId: '',
        quotedProductId: '',
        productId: '',
        color: '',
        // e.g '80x18'
        dimensions: '',
        iconRatio: '',
        nameMax: null,
        nameSize: null,
        // e.g '13x9'
        photoSize: '',
        product: '',
        // e.g 'R,T,L'
        ratios: '',
        // e.g 'Rectangle'
        shape: '',
        // size must be a single letter
        size: '',
        sugarId: '',
        icon: '',
        // iconPlacement can only be 'Left' or 'Right'
        iconPlacement: 'Left',
        // iconPosition is an object with two keys: x and y
        iconPosition: {
            x: 0,
            y: 0
        },
        // Object with 3 keys: text, size and font
        petName: {
            text: '',
            size: null,
            font: 'Arial',
            max: 0
        },
        // Object with 3 keys: text, size and font
        primaryText: {
            text: '',
            size: null,
            font: 'Arial',
            max: 0
        },
        // Object with 3 keys: text, size and font
        secondaryText: {
            text: '',
            size: null,
            font: 'Arial',
            max: 0
        },
        customTextImage: '',
        engravingOptionsImage: '',
        imageOptions: {
            croppedImage: null,
            fileImgSrc: null,
            croppedAreaPixels: null,
            aspectW: 500,
            aspectH: 500
        },
        customImage: '',
        isApproved: false,
        isEditable: false,
        customText: '',
    };

    newEngravingObj = createModelInstance(newEngravingObj, engravingInput);

    return {
        ...newEngravingObj,
        toSubmitFormat(imageOptionsUrl, engravingOptionsUrl) {
            return {
                engraving_files: [
                    {
                        imageOptionsUrl
                    },
                    {
                        engravingOptionsUrl
                    }
                ],
                others: this
            };
        }
    };
};

export default Engraving;
